<template>
    <div>
        <body class="hold-transition dark-mode sidebar-mini sidebar-collapse">
            <menu-lateral></menu-lateral>
            <menu-top></menu-top>

            <div class="content-wrapper">
                <imgChevron></imgChevron>

                <section class="content">
                    <div class="container-fluid">
                        <div class="row">
                            <section class="col-lg-12 connectedSortable">
                                <div class="card caja_tabla t_q">
                                    <div class="card-header cabecera">
                                        <i class="fa-solid fa-inbox"></i>
                                        <h3 class="card-title titulo">Mensajes</h3>
                                    </div>

                                    <!-- Contenedor notificaciones -->
                                    <div class="contenedor_mensajes">
                                        <div class="grupo_mensajes">
                                            <div v-for="dato in mensajesCliente" :key="dato.notificacionID" class="mensaje"
                                            :class="{'mensaje_pendiente': dato.leido === false}">
                                                <div class="not_cabecera">
                                                    <div class="not_fecha">
                                                        {{ dato.fechaMensaje | formatDateTime }}
                                                    </div>
                                                    <div class="not_leido" v-if="dato.leido === false">
                                                        <p class="marcar_leido" @click="marcarLeido(dato.notificacionID)">Marcar como leido</p>
                                                    </div>
                                                </div>
                                                <div class="not_mensaje">
                                                    {{ dato.mensaje }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    

                                    <div class="paginado">
                                        <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"
                                        aria-controls="tabla"
                                        class="diseño_paginacion">
                                        </b-pagination>

                                        <div class="pagina">
                                        <p>Página: {{ currentPage }}</p>
                                        <b-spinner variant="primary" v-if="show"></b-spinner>
                                        </div>
                                    </div>

                                </div>
                            </section>
                        </div>
                    </div>
                </section>

            </div>
            <menu-footer></menu-footer>
        </body>
    </div>
</template>

<script>
import menuLateral from '../components/menuLateral.vue'
import menuFooter from '../components/menuFooterBotton.vue'
import menuTop from '../components/navBarMenu.vue'
import imgChevron from '@/components/imgChevron.vue'
import servicioCliente from '@/services/servicioCliente';
export default {
    components: { menuLateral, menuFooter, menuTop, imgChevron },
    data(){
        return{
            ClienteID: 0,
            perPage: 10,
            currentPage: 1,
            show: false,

            mensajesCliente:[]
        }
    },
    computed: {
        rows() {
            return this.mensajesCliente.length
        }
    },
    mounted(){
        this.ClienteID = localStorage.getItem("clienteID");

        this.obtenerNotificaciones();
    },
    methods:{
        //Obtener mensajes
        async obtenerNotificaciones(){
            try{

                const payload={
                    ClienteID:this.ClienteID
                };

                const result = await servicioCliente.consultarNotificaciones(1,payload);
                this.mensajesCliente = result.data;
                
            }
            catch(error){
                this.$msg.error("No es posible consultar la Información");
            }
        },

        //Método para marcar como leido
        async marcarLeido(notificacionID){
            try{
                const payload={
                    NotificacionID: notificacionID
                };

                const result = await servicioCliente.consultarNotificaciones(3,payload);
                if(result.value != true){
                    this.$msg.error(result.message || "Error al marcar como leido");
                    return;
                }

                //Cambiar visualmente en la lista
                const notificacion = this.mensajesCliente.find(
                    m => m.notificacionID === notificacionID
                );

                if(notificacion){
                    notificacion.leido = true
                }
                
            }
            catch(error){
                this.$msg.error("Error al marcar el mensaje como leido");
            }
        }
    }
}
</script>

<style scoped>
.caja_tabla{
    min-height: 400px;
}
</style>
